import { AST } from '@handlebars/parser';

export type StatementWithArgs =
  | AST.BlockStatement
  | AST.PartialBlockStatement
  | AST.PartialStatement
  | AST.MustacheStatement;

export type StatementListSerializerFn = (statements: AST.Statement[]) => string;

export enum IterableMustachePaths {
  Snippet = 'snippet',
  DateMath = 'dateMath',
}
